import React, {useEffect, useState} from 'react';
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import {Col} from "react-bootstrap";
import {TextField} from "@mui/material";
import { Checkbox } from "primereact/checkbox";
import { Row } from "react-bootstrap";
import {InputLabel, MenuItem, Select, Box, FormControl,} from '@mui/material';
import { RadioButton } from "primereact/radiobutton";
import {Button} from "primereact/button";
import { useNavigate} from "react-router-dom";
import { collection, addDoc, getDocs } from "firebase/firestore";
import { db } from "../../FireBase/firestore";
import { Snackbar, Alert } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { Accordion, AccordionTab } from 'primereact/accordion';

const CheckOut = () => {
    const [snackbar, setSnackbar] = useState({open: false, severity: 'success', message: ''});
    const showMessage = (severity, message) => {setSnackbar({ open: true, severity, message });};
    const navigate = useNavigate();
    const [contact, setContact] = useState('');
    const [checkContact, setCheckContact] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState('Pakistan');
    const [paymentMethod, setPaymentMethod] = useState('COD');
    const [billingAddress, setBillingAddress] = useState('SameAsShipping');
    const [dataArray, setDataArray] = useState([]);
    const [loading, setLoading] = useState(false);
    const loadCartData = () => {
        const dataItems = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.startsWith("cartItem-")) {
                try {
                    const item = localStorage.getItem(key);
                    if (item) {
                        const parsedItem = JSON.parse(item);
                        dataItems.push(parsedItem);
                    }
                } catch (err) {
                    console.warn(`Could not parse localStorage item for key: ${key}`, err);
                }
            }
        }
        setDataArray(dataItems);
    };

    useEffect(() => {
        loadCartData();
    }, []);
    const calculateEstimatedTotal = () => {
        return dataArray.reduce((acc, item) => {
            const price = parseFloat(item.productPrice.replace("Rs.", "").replace(/,/g, "").trim());
            const quantity = Number(item.productQuantity);
            return acc + (price * quantity);
        }, 0);
    };
    const shipping = 200;
    const subtotal = calculateEstimatedTotal();
    const total = subtotal + shipping;
    const formattedSubtotal = subtotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const formattedTotal = total.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const handleChange = (event) => {setSelectedCountry(event.target.value);};
    const countries = [
        { code: 'Pakistan', label: 'Pakistan' },
        { code: 'United States', label: 'United States' },
        { code: 'United Kingdom', label: 'United Kingdom' },
    ];
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [apartmentSuite, setApartmentSuite] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [phone, setPhone] = useState('');
    const [saveInfo, setSaveInfo] = useState('');
    const isMobile = window.innerWidth <= 440;
    const handleCloseSnackbar = () => {setSnackbar({ ...snackbar, open: false });};
    const validateForm = () => {
        if (!contact.trim()) {
            showMessage('error', 'Email is required');
            return false;
        }
        else if (!/^\S+@\S+\.\S+$/.test(contact)) {
            showMessage('error', 'Enter a valid email address');
            return false;
        }
        if (!firstName.trim()) {
            showMessage('error', 'First name is required');
            return false;
        }
        if (!lastName.trim()) {
            showMessage('error', 'Last name is required');
            return false;
        }
        if (!address.trim()){
            showMessage('error', 'Address is required');
            return false;
        }
        if (!city.trim()) {
            showMessage('error', 'City is required');
            return false;
        }
        if (!phone.trim()) {
            showMessage('error', 'Phone number is required');
            return false;
        }
        else if (!/^03[0-9]{9}$/.test(phone)) {
            showMessage('error', 'Enter valid phone (03001234567)');
            return false;
        }
        if (!selectedCountry) {
            showMessage('error', 'Country is required');
            return false;
        }
        return true;
    };
    const handleCompleteOrder = async () => {
        if (!validateForm()) {
            return;
        }
        setLoading(true);
        saveCheckoutData();
        const orderId = await saveOrderToFirebase();
        if (orderId) {
            const keysToDelete = [];
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key && key.startsWith("cartItem-")) {
                    keysToDelete.push(key);
                }
            }
            keysToDelete.forEach(key => localStorage.removeItem(key));
            localStorage.removeItem("checkoutData");
            navigate(`/orders/${orderId}`);
        }
        setLoading(false);
    };
    const cartItems = {
        items: dataArray,
        subtotal: subtotal,
        formattedSubtotal: formattedSubtotal,
        shipping: shipping,
        total: total,
        formattedTotal: formattedTotal,
        totalItems: dataArray.reduce((acc, item) => acc + item.productQuantity, 0)
    };
    const saveCheckoutData = () => {
        const checkoutData = {
            contact,
            checkContact,
            selectedCountry,
            paymentMethod,
            billingAddress,
            firstName,
            lastName,
            address,
            apartmentSuite,
            city,
            postalCode,
            phone,
            saveInfo,
            cartItems,
            subtotal,
            shipping,
            total
        };
        localStorage.setItem("checkoutData", JSON.stringify(checkoutData));
    };
    const saveOrderToFirebase = async () => {
        try {
            const querySnapshot = await getDocs(collection(db, "orders"));
            const orderCount = querySnapshot.size + 1;
            const orderId = String(orderCount).padStart(3, "0");
            const orderData = {
                orderId:orderId,
                contact,
                firstName,
                lastName,
                address,
                city,
                selectedCountry,
                phone,
                paymentMethod,
                cartItems,
                subtotal,
                shipping,
                total,
                status: "Pending",
                createdAt: new Date()
            };
            const docRef = await addDoc(collection(db, "orders"), orderData);
            return docRef.id;
        } catch (error) {
            console.error("Error saving order:", error);
            return null;
        }
    };

    useEffect(() => {
        const savedData = localStorage.getItem("checkoutData");
        if (savedData) {
            const data = JSON.parse(savedData);
            setContact(data.contact || "");
            setCheckContact(data.checkContact || false);
            setSelectedCountry(data.selectedCountry || "Pakistan");
            setPaymentMethod(data.paymentMethod || "COD");
            setBillingAddress(data.billingAddress || "SameAsShipping");
            setFirstName(data.firstName || "");
            setLastName(data.lastName || "");
            setAddress(data.address || "");
            setApartmentSuite(data.apartmentSuite || "");
            setCity(data.city || "");
            setPostalCode(data.postalCode || "");
            setPhone(data.phone || "");
            setSaveInfo(data.saveInfo || false);
        }
    }, []);
    return (
        <div className="bg-offWhite">
            <NavBar />
            <div className="custom-top-padding">
                <Row className="m-0">
                    {isMobile && (
                        <Col md={5} lg={5} sm={12} xs={12} className='mb-4'>
                            <Accordion activeIndex={0}>
                                <AccordionTab header="Order Summary ">
                                    <div style={{background: '#f9f9f9', padding: '24px', borderRadius: '10px', margin: 'auto'}}>
                                        {dataArray.map((item, idx) => (
                                            <div key={idx} style={{display: 'flex', justifyContent: 'space-between', marginBottom: '20px'}}>
                                                <div style={{ display: 'flex' }}>
                                                    <div style={{ position: 'relative', marginRight: '10px' }}>
                                                        <img src={item.productImage} alt={item.productName} style={{width: '60px', height: '60px', borderRadius: '5px', objectFit: 'cover'}} loading="lazy"/>
                                                        <span style={{position: 'absolute', top: '-8px', left: '-8px', backgroundColor: '#444', color: '#fff', borderRadius: '50%', width: '22px', height: '22px', fontSize: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>{item.productQuantity}</span>
                                                    </div>
                                                    <div>
                                                        <div style={{ fontWeight: 'bold' }}>{item.productName}</div>
                                                        <div style={{fontSize: '13px', color: '#777'}}>{item.productColor} / {item.productSize}</div>
                                                    </div>
                                                </div>
                                                <div style={{ fontWeight: 500 }}>{item.productPrice}</div>
                                            </div>
                                        ))}
                                        <div style={{ fontSize: '14px', marginTop: '20px' }}>
                                            <div className="d-flex justify-content-between">
                                                    <span>Subtotal · {dataArray.reduce((acc, item) => acc + item.productQuantity, 0)} items</span>
                                                    <span>Rs.{formattedSubtotal}</span>
                                            </div>
                                            <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '8px'}}>
                                                <span>Shipping</span>
                                                <span>{shipping}</span>
                                            </div>
                                            <hr style={{ margin: '12px 0' }} />
                                            <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', fontSize: '18px' }}>
                                                <div style={{ fontWeight: '700', fontSize: '17px' }}>Total</div>
                                                <div><span style={{ color: '#888', fontSize: '13px' }}>PKR</span>{' '}Rs.{formattedTotal}</div>
                                            </div>
                                        </div>
                                    </div>
                                </AccordionTab>
                            </Accordion>
                    </Col>)}
                    <Col md={7} lg={7} sm={12} xs={12}>
                        <h4 className="fw-bold mb-4">Contact</h4>
                        <Col lg={12} className="mb-4">
                            <TextField label="Email*" value={contact} onChange={(e) => setContact(e.target.value)} className="w-100"/>
                        </Col>
                        <Col lg={12}>
                            <Checkbox inputId='checkContact' onChange={e => setCheckContact(e.checked)} checked={checkContact}></Checkbox>
                            <label htmlFor="checkContact" className="ms-2">E-mail me with news and offers</label>
                        </Col>
                        <h4 className="fw-bold mt-5 mb-4">Delivery</h4>
                        <Col lg={12} className="mb-4">
                            <Box sx={{ minWidth: 300 }}>
                                <FormControl fullWidth>
                                    <InputLabel id="country-select-label">Country*</InputLabel>
                                    <Select labelId="country-select-label" id="country-select" value={selectedCountry} label="Country" onChange={handleChange}>
                                        {countries.map((country) => (
                                            <MenuItem key={country.code} value={country.code}>{country.label}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        </Col>
                        <Col lg={12} className="mb-4">
                            <Row>
                                <Col lg={6} md={6} sm={12} className="custom-checkout-margin">
                                    <TextField label="First Name*" value={firstName} onChange={(e) => setFirstName(e.target.value)} className="w-100"/>
                                </Col>
                                <Col lg={6} md={6} sm={12}>
                                    <TextField label="Last Name*" value={lastName} onChange={(e) => setLastName(e.target.value)} className="w-100"/>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12} className="mb-4">
                            <TextField label="Address*" value={address} onChange={(e) => setAddress(e.target.value)} className="w-100"/>
                        </Col>
                        <Col lg={12} className="mb-4">
                            <TextField label="Apartment,suite,etc (Optional)" value={apartmentSuite} onChange={(e) => setApartmentSuite(e.target.value)} className="w-100"/>
                        </Col>
                        <Col lg={12} className="mb-4">
                            <Row>
                                <Col lg={6} className="custom-checkout-margin">
                                    <TextField label="City*" value={city} onChange={(e) => setCity(e.target.value)} className="w-100"/>
                                </Col>
                                <Col lg={6}>
                                    <TextField label="Postal Code (Optional)" value={postalCode} onChange={(e) => setPostalCode(e.target.value)} className="w-100"/>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12} className="mb-4">
                            <TextField label="Phone*" value={phone} onChange={(e) => setPhone(e.target.value)} className="w-100"/>
                        </Col>
                        <Col lg={12}>
                            <Checkbox inputId='checkSaveInfo' onChange={e => setSaveInfo(e.checked)} checked={saveInfo}></Checkbox>
                            <label htmlFor="checkSaveInfo" className="ms-2">Save this information for the next time</label>
                        </Col>
                        <Col lg={12} style={{ fontFamily: "Arial, sans-serif" }}>
                            <h4 className="fw-bold mt-5 mb-4">Shipping Method</h4>
                            <div style={{border: "1px solid #007bff", backgroundColor: "#f0f6ff", padding: "12px 16px", borderRadius: "6px", display: "flex", justifyContent: "space-between", alignItems: "center",}}>
                                <span style={{ color: "#333" }}>Shipping Fee</span>
                                <span style={{ fontWeight: "bold", color: "#000" }}>Rs 200.00</span>
                            </div>
                        </Col>
                        <Col lg={12}>
                            <h4 className="fw-bold mt-5 mb-4">Payment Method</h4>
                            <div className="flex flex-column gap-3">
                                <div className="card flex justify-content-center p-3" style={paymentMethod === 'COD' ? {border: "1px solid #007bff", backgroundColor: "#f0f6ff", borderRadius: "6px"} : {}}>
                                    <div className="flex flex-wrap gap-3">
                                        <div className="flex align-items-center">
                                            <RadioButton inputId="COD" name="paymentMethod" value="COD" onChange={(e) => setPaymentMethod(e.value)} checked={paymentMethod === 'COD'}/>
                                            <label htmlFor="COD" className="ms-2">Cash On Delivery (COD)</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="card flex flex-column justify-content-center p-3"
                                     style={paymentMethod === 'BankDeposit' ? {border: "1px solid #007bff", backgroundColor: "#f0f6ff", borderRadius: "6px"} : {}}>
                                    <div className="flex flex-wrap gap-3">
                                        <div className="flex align-items-center">
                                            <RadioButton inputId="BankDeposit" name="paymentMethod" value="BankDeposit" onChange={(e) => setPaymentMethod(e.value)} checked={paymentMethod === 'BankDeposit'}/>
                                            <label htmlFor="BankDeposit" className="ms-2">Bank Deposit</label>
                                        </div>
                                    </div>
                                    {paymentMethod === 'BankDeposit' && (
                                        <div className="mt-3 p-3 border rounded" style={{ backgroundColor: "#ffffff" }}>
                                            <ul className="mt-2 mb-4 ms-3 text-sm text-gray-700 custom-fs-11-checkout">
                                                <li><strong>Bank Name:</strong>Meezan Bank- GONDLANWALA RD GUJ</li>
                                                <li><strong>Account Name:</strong>MUHAMMAD BADAR MUNIR</li>
                                                <li><strong>Account Number:</strong>09090106676073</li>
                                                <li><strong>IBAN:</strong>PK58MEZN0009090106676073</li>
                                            </ul>
                                            <ul className="ms-3 text-sm text-gray-800 custom-fs-11-checkout">
                                                <li>Note:</li>
                                                <li>Use your Order ID as reference number.</li>
                                                <li> After Payment send Receipt on WhatsApp: 03054973841</li>
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Col>
                        <Col lg={12}>
                            <h4 className="fw-bold mt-5 mb-4">Billing Address</h4>
                            <div className="flex flex-column gap-3">
                                <div className="card flex justify-content-center p-3" style={billingAddress === 'SameAsShipping' ? {border: "1px solid #007bff", backgroundColor: "#f0f6ff", borderRadius: "6px"} : {}}>
                                    <div className="flex flex-wrap gap-3">
                                        <div className="flex align-items-center">
                                            <RadioButton inputId="SameAsShipping" name="billingAddress" value="SameAsShipping" onChange={(e) => setBillingAddress(e.value)} checked={billingAddress === 'SameAsShipping'}/>
                                            <label htmlFor="SameAsShipping" className="ms-2">Same As Shipping Address</label>
                                        </div>
                                    </div>
                                </div>
                                {/*<div className="card flex flex-column justify-content-center p-3"*/}
                                {/*     style={billingAddress === 'UseDifferentAddress' ? {*/}
                                {/*         border: "1px solid #007bff",*/}
                                {/*         backgroundColor: "#f0f6ff",*/}
                                {/*         borderRadius: "6px"*/}
                                {/*     } : {}}*/}
                                {/*>*/}
                                    {/*<div className="flex flex-wrap gap-3">*/}
                                    {/*    <div className="flex align-items-center">*/}
                                    {/*        <RadioButton*/}
                                    {/*            inputId="UseDifferentAddress"*/}
                                    {/*            name="billingAddress"*/}
                                    {/*            value="UseDifferentAddress"*/}
                                    {/*            onChange={(e) => setBillingAddress(e.value)}*/}
                                    {/*            checked={billingAddress === 'UseDifferentAddress'}*/}
                                    {/*        />*/}
                                    {/*        <label htmlFor="UseDifferentAddress" className="ms-2">Use A Different Billing Address</label>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    {/*{billingAddress === 'UseDifferentAddress' && (*/}
                                    {/*    <div className="mt-3 p-4 border rounded" style={{ backgroundColor: "#ffffff" }}>*/}
                                    {/*        <Col lg={12} className="mb-4">*/}
                                    {/*            <FormControl fullWidth>*/}
                                    {/*                <InputLabel id="country-select-label">Country</InputLabel>*/}
                                    {/*                <Select*/}
                                    {/*                    labelId="country-select-label"*/}
                                    {/*                    id="country-select"*/}
                                    {/*                    value={selectedCountry}*/}
                                    {/*                    label="Country"*/}
                                    {/*                    onChange={handleChange}*/}
                                    {/*                >*/}
                                    {/*                    {countries.map((country) => (*/}
                                    {/*                        <MenuItem key={country.code} value={country.code}>*/}
                                    {/*                            {country.label}*/}
                                    {/*                        </MenuItem>*/}
                                    {/*                    ))}*/}
                                    {/*                </Select>*/}
                                    {/*            </FormControl>*/}
                                    {/*        </Col>*/}
                                    {/*        <Col lg={12} className="mb-4">*/}
                                    {/*            <Row>*/}
                                    {/*                <Col lg={6} md={6} sm={12}>*/}
                                    {/*                    <TextField*/}
                                    {/*                        label="First Name"*/}
                                    {/*                        value={firstName}*/}
                                    {/*                        onChange={(e) => setFirstName(e.target.value)}*/}
                                    {/*                        className="w-100"*/}
                                    {/*                    />*/}
                                    {/*                </Col>*/}
                                    {/*                <Col lg={6} md={6} sm={12}>*/}
                                    {/*                    <TextField*/}
                                    {/*                        label="Last Name"*/}
                                    {/*                        value={lastName}*/}
                                    {/*                        onChange={(e) => setLastName(e.target.value)}*/}
                                    {/*                        className="w-100"*/}
                                    {/*                    />*/}
                                    {/*                </Col>*/}
                                    {/*            </Row>*/}
                                    {/*        </Col>*/}
                                    {/*        <Col lg={12} className="mb-4">*/}
                                    {/*            <TextField*/}
                                    {/*                label="Address"*/}
                                    {/*                value={address}*/}
                                    {/*                onChange={(e) => setAddress(e.target.value)}*/}
                                    {/*                className="w-100"*/}
                                    {/*            />*/}
                                    {/*        </Col>*/}
                                    {/*        <Col lg={12} className="mb-4">*/}
                                    {/*            <TextField*/}
                                    {/*                label="Apartment,suite,etc (Optional)"*/}
                                    {/*                value={apartmentSuite}*/}
                                    {/*                onChange={(e) => setApartmentSuite(e.target.value)}*/}
                                    {/*                className="w-100"*/}
                                    {/*            />*/}
                                    {/*        </Col>*/}
                                    {/*        <Col lg={12} className="mb-4">*/}
                                    {/*            <Row>*/}
                                    {/*                <Col lg={6}>*/}
                                    {/*                    <TextField*/}
                                    {/*                        label="City"*/}
                                    {/*                        value={city}*/}
                                    {/*                        onChange={(e) => setCity(e.target.value)}*/}
                                    {/*                        className="w-100"*/}
                                    {/*                    />*/}
                                    {/*                </Col>*/}
                                    {/*                <Col lg={6}>*/}
                                    {/*                    <TextField*/}
                                    {/*                        label="Postal Code (Optional)"*/}
                                    {/*                        value={postalCode}*/}
                                    {/*                        onChange={(e) => setPostalCode(e.target.value)}*/}
                                    {/*                        className="w-100"*/}
                                    {/*                    />*/}
                                    {/*                </Col>*/}
                                    {/*            </Row>*/}
                                    {/*        </Col>*/}
                                    {/*        <Col lg={12} className="mb-2">*/}
                                    {/*            <TextField*/}
                                    {/*                label="Phone"*/}
                                    {/*                value={phone}*/}
                                    {/*                onChange={(e) => setPhone(e.target.value)}*/}
                                    {/*                className="w-100"*/}
                                    {/*            />*/}
                                    {/*        </Col>*/}
                                    {/*    </div>*/}
                                    {/*)}*/}
                                {/*</div>*/}
                            </div>
                        </Col>
                        <Col lg={12}>
                            <Button filled disabled={loading} className='text-white br-10 w-100 mt-4 text-center d-flex justify-content-center fw-bold' style={{ backgroundColor: '#A6CE3A', borderColor: '#A6CE3A' }} onClick={handleCompleteOrder}>
                                {loading ? <CircularProgress size={24} color="inherit" /> : "Complete Order"}
                            </Button>
                        </Col>
                    </Col>
                    {!isMobile && (<Col md={5} lg={5} sm={12} xs={12}>
                        <div style={{ background: '#f9f9f9', padding: '24px', borderRadius: '10px', maxWidth: '500px', margin: 'auto' }}>
                            {dataArray.map((item, idx) => (
                                <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                                    <div style={{ display: 'flex' }}>
                                        <div style={{ position: 'relative', marginRight: '10px' }}>
                                            <img src={item.productImage} alt={item.productName} style={{ width: '60px', height: '60px', borderRadius: '5px', objectFit: 'cover' }} loading="lazy"/>
                                            <span style={{position: 'absolute', top: '-8px', left: '-8px', backgroundColor: '#444', color: '#fff', borderRadius: '50%', width: '22px', height: '22px', fontSize: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>{item.productQuantity}</span>
                                        </div>
                                        <div>
                                            <div style={{ fontWeight: 'bold' }}>{item.productName}</div>
                                            <div style={{ fontSize: '13px', color: '#777' }}>{item.productColor} / {item.productSize}</div>
                                        </div>
                                    </div>
                                    <div style={{ fontWeight: 500 }}>{item.productPrice}</div>
                                </div>
                            ))}
                            <div style={{ fontSize: '14px', marginTop: '20px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span>Subtotal · {dataArray.reduce((acc, item) => acc + item.productQuantity, 0)} items</span>
                                    <span>Rs.{formattedSubtotal}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
                                    <span>Shipping</span>
                                    <span>{shipping}</span>
                                </div>
                                <hr style={{ margin: '12px 0' }} />
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', fontSize: '18px' }}>
                                    <div style={{ fontWeight: '700', fontSize: '17px' }}>Total</div>
                                    <div><span style={{ color: '#888', fontSize: '13px' }}>PKR</span>{' '}Rs.{formattedTotal}</div>
                                </div>
                            </div>
                        </div>
                    </Col>)}
                </Row>
            </div>
            <Footer />
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    )
}
export default CheckOut;